import { Link } from "@fluentui/react/lib/Link"
import { Stack } from "@fluentui/react/lib/Stack"
import { IProcessedStyleSet } from "@fluentui/react/lib/Styling"
import { Text } from "@fluentui/react/lib/Text"
import { classNamesFunction, styled } from "@fluentui/react/lib/Utilities"
import parse from "html-react-parser"
import React, { useState } from "react"

import { L10n } from "@encoway/l10n"

import { ProductTextStyles } from "./ProductText.styles"
import { IProductTextStyles, ProductTextProps } from "./ProductText.types"

/**
 * The ProductText component renders the short and long text of a ContainerTO.
 *
 * Links:
 * - [Checkout the code](https://gitlab.encoway-services.de/pd/dev/encoway-cpq/-/blob/master/cui/features/application-components/src/components/ProductText/ProductText.tsx)
 * - [ProductTextStyles](https://gitlab.encoway-services.de/pd/dev/encoway-cpq/-/blob/master/cui/features/application-components/src/components/ProductText/ProductText.styles.ts)
 * - [ProductTextProps](https://gitlab.encoway-services.de/pd/dev/encoway-cpq/-/blob/master/cui/features/application-components/src/components/ProductText/ProductText.types.ts)
 * - [html-to-react (long text parsing)](https://www.npmjs.com/package/html-to-react)
 *
 * @visibleName ProductText
 */
function IProductText(props: ProductTextProps) {
    const { styles, theme, container } = props
    const classNames = classNamesFunction()(
        styles,
        theme
    ) as IProcessedStyleSet<IProductTextStyles>

    const [expanded, setExpanded] = useState(false)

    const shortText = container.shortText
    const longText = container.longText

    return (
        <Stack className={classNames.root}>
            {shortText && (
                <Text className={classNames.shortText}>{shortText}</Text>
            )}
            {longText && expanded && (
                <Text className={classNames.longText}>{parse(longText)}</Text>
            )}
            {longText && (
                <Link
                    className={classNames.link}
                    onClick={() => setExpanded(!expanded)}
                >
                    {expanded
                        ? L10n.format("Application.Header.ProductText.less")
                        : L10n.format("Application.Header.ProductText.more")}
                </Link>
            )}
        </Stack>
    )
}

export const ProductText = styled(IProductText, ProductTextStyles)
